// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 237 ? "pages" : chunkId) + "-legacy." + {"92":"05a20de5","237":"08da1b69","668":"0a5c6d23","739":"96563d81"}[chunkId] + ".js";
};